export default function parserStringDateToDate(stringDate: string) {
  const [day, month, year] = stringDate.split('/')

  return new Date(+year, +month - 1, +day)
}
